/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes, { instanceOf } from 'prop-types';
import initStore from '@/src/redux/init';

const isServer = typeof window === 'undefined';
const __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__';

function getOrCreateStore(initialState) {
  // Always make a new store if server, otherwise state is shared between requests
  if (isServer) {
    return initStore(initialState);
  }

  // Create store if unavailable on the client and set it on the window object
  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = initStore(initialState);
  }
  return window[__NEXT_REDUX_STORE__];
}

export default (App) => {
  class AppWithRedux extends React.Component {
    static async getInitialProps(appContext) {
      const appCtx = appContext;
      // Get or Create the store with `undefined` as initialState
      // This allows you to set a custom default initialState
      const reduxStore = getOrCreateStore();

      // Provide the store to getInitialProps of pages
      appCtx.ctx.reduxStore = reduxStore;

      let appProps = {};
      if (typeof App.getInitialProps === 'function') {
        appProps = await App.getInitialProps(appContext);
      }

      return {
        ...appProps,
        initialReduxState: reduxStore.getState(),
      };
    }

    constructor(props) {
      super(props);
      this.reduxStore = getOrCreateStore(props.initialReduxState);
    }

    render() {
      return <App {...this.props} reduxStore={this.reduxStore} />;
    }
  }

  AppWithRedux.defaultProps = {
    reduxStore: null,
    headManager: null,
    err: null,
  };

  AppWithRedux.propTypes = {
    lang: PropTypes.string.isRequired,
    cookies: PropTypes.object.isRequired,
    urlParams: PropTypes.object.isRequired,
    reduxStore: PropTypes.object,
    headManager: PropTypes.object,
    initialReduxState: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    err: PropTypes.any,
    Component: PropTypes.oneOfType([PropTypes.func, instanceOf(App)]).isRequired,
  };

  return AppWithRedux;
};
